const storeInSession = (key, value) => {
  return sessionStorage.setItem(key, value);
};

const storeInLocalStorage = (key, value) => {
  return localStorage.setItem(key, value);
};

const lookInLocalStorage = (key) => {
  return localStorage.getItem(key);
};

const clearLocalStorage = () => {
  return localStorage.clear();
};

const lookInSession = (key) => {
  return sessionStorage.getItem(key);
};

const removeFromSession = (key) => {
  return sessionStorage.removeItem(key);
};

const logOutUser = () => {
  sessionStorage.clear();
};

export {
  storeInSession,
  lookInSession,
  removeFromSession,
  logOutUser,
  storeInLocalStorage,
  lookInLocalStorage,
  clearLocalStorage,
};
